import {
  Box,
  Popover,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
} from '@chakra-ui/react'
import { BsFillChatDotsFill } from 'react-icons/bs'
import { WidgetForm } from './WidgetForm'

export function Feedback() {
  return (
    <Popover>
      <PopoverTrigger>
        <Box
          position="fixed"
          bottom="1rem"
          right="1rem"
          cursor="pointer"
          zIndex="1000"
          width="4rem"
          height="4rem"
          borderRadius="50%"
          backgroundColor="#378bbf"
          display="flex"
          justifyContent="center"
          alignItems="center"
          boxShadow="0 0 0 1px rgba(0,0,0,0.1), 0 2px 4px rgba(0,0,0,0.2)"
        >
          <BsFillChatDotsFill size="2rem" color="white" />
        </Box>
      </PopoverTrigger>
      <PopoverContent
        width="25rem"
        height="100%"
        backgroundColor="gray.50"
        boxShadow="0 0 0 1px rgba(0,0,0,0.1), 0 2px 4px rgba(0,0,0,0.2)"
        right="1rem"
      >
        <PopoverCloseButton
          borderRadius="50%"
          backgroundColor="#378bbf"
          color="white"
          boxShadow="0 0 0 1px rgba(0,0,0,0.1), 0 2px 4px rgba(0,0,0,0.2)"
          _hover={{
            backgroundColor: '#378bbf',
          }}
        />
        <PopoverHeader>Abrir novo chamado de suporte</PopoverHeader>
        <PopoverBody>
          <WidgetForm />
        </PopoverBody>
      </PopoverContent>
    </Popover>
  )
}
